import { captureStack1fzi4aczwc4hg as captureStack } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  RuntimeException1r3t0zl97011n as RuntimeException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlinx_datetime_DateTimeFormatException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.x1m_1);
}
var DateTimeFormatExceptionClass;
function DateTimeFormatException() {
  if (DateTimeFormatExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static x1n() {
        var $this = this.xd();
        init_kotlinx_datetime_DateTimeFormatException($this);
        return $this;
      }
      static y1m(message) {
        var $this = this.a1(message);
        init_kotlinx_datetime_DateTimeFormatException($this);
        return $this;
      }
      static y1n(cause) {
        var $this = this.be(cause);
        init_kotlinx_datetime_DateTimeFormatException($this);
        return $this;
      }
      static z1n(message, cause) {
        var $this = this.zd(message, cause);
        init_kotlinx_datetime_DateTimeFormatException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'DateTimeFormatException', $.x1n);
    DateTimeFormatExceptionClass = $;
  }
  return DateTimeFormatExceptionClass;
}
function init_kotlinx_datetime_IllegalTimeZoneException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.d1o_1);
}
var IllegalTimeZoneExceptionClass;
function IllegalTimeZoneException() {
  if (IllegalTimeZoneExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static e1o() {
        var $this = this.xd();
        init_kotlinx_datetime_IllegalTimeZoneException($this);
        return $this;
      }
      static f1o(cause) {
        var $this = this.be(cause);
        init_kotlinx_datetime_IllegalTimeZoneException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalTimeZoneException', $.e1o);
    IllegalTimeZoneExceptionClass = $;
  }
  return IllegalTimeZoneExceptionClass;
}
function init_kotlinx_datetime_DateTimeArithmeticException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.i1o_1);
}
var DateTimeArithmeticExceptionClass;
function DateTimeArithmeticException() {
  if (DateTimeArithmeticExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static j1o() {
        var $this = this.yd();
        init_kotlinx_datetime_DateTimeArithmeticException($this);
        return $this;
      }
      static k1o(cause) {
        var $this = this.ce(cause);
        init_kotlinx_datetime_DateTimeArithmeticException($this);
        return $this;
      }
      static l1o(message, cause) {
        var $this = this.ae(message, cause);
        init_kotlinx_datetime_DateTimeArithmeticException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'DateTimeArithmeticException', $.j1o);
    DateTimeArithmeticExceptionClass = $;
  }
  return DateTimeArithmeticExceptionClass;
}
//region block: exports
export {
  DateTimeArithmeticException as DateTimeArithmeticException3b9ehoczpp1e2,
  DateTimeFormatException as DateTimeFormatException2onfeknbywaob,
  IllegalTimeZoneException as IllegalTimeZoneException2q01rvpc2etsw,
};
//endregion

//# sourceMappingURL=Exceptions.mjs.map
